import * as React from 'react';
import easingEquations from 'utils/easingEquations';
import { numFormat } from 'utils/numFormat';
export default class NumbersAnimator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value
        };
        this.currentTime = 0;
        this.prevValue = 0;
        this.animateTo = this.animateTo.bind(this);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
            this.currentTime = 0;
            this.prevValue = this.props.value;
            // Cancelling previous animation if exists before starting a new one
            if (this.animationId) {
                window.cancelAnimationFrame(this.animationId);
            }
            this.animateTo(nextProps.value);
        }
    }
    animateTo(nextValue) {
        this.currentTime += 1 / 60;
        const p = this.currentTime / this.props.time;
        if (p < 1) {
            this.animationId = window.requestAnimationFrame(() => this.animateTo(nextValue));
            const value = this.prevValue + (nextValue - this.prevValue) * easingEquations[this.props.easing](p);
            this.setState({ value });
        }
        else {
            this.setState({ value: nextValue });
        }
    }
    render() {
        const { value } = this.state;
        let finalValue = value.toFixed(this.props.fixed);
        if (this.props.localeString)
            finalValue = numFormat(Number(finalValue));
        return <span>{finalValue}</span>;
    }
}
NumbersAnimator.defaultProps = {
    time: 1,
    localeString: true,
    fixed: 0,
    easing: 'easeOutSine'
};
